import React, { useEffect, useState, useRef } from "react";
import { Map, View } from "ol";
import { connect } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Styles from "./ProfileLocalizeMe.scss";
import TileLayer from "ol/layer/Tile";
import { OSM } from "ol/source";
import { INIT_CENTER } from "../../../constants";
//import {defaults as defaultControls} from "ol/control/util";
import { Control, defaults as baseControls } from "ol/control";
import { fromLonLat, transform, toLonLat } from "ol/proj";
import useDebounce from "../../../components/utilities/useDebounce";
import UserPrefsService from "../../../services/UserPrefsService";
import { defaults as defaultInteractions, DragRotateAndZoom } from "ol/interaction";
import Icon from "@mdi/react";
import { mdiContentSave, mdiContentSaveCog, mdiEraser } from "@mdi/js";
import CommuneSearch from "./CommuneSearch";
import ProfileSaveLayer from "./ProfileSaveLayers";
import NumberFormat from "react-number-format";

class GraticuleControl extends Control {
   constructor(opt_options) {
      const options = opt_options || {};
      const element = document.createElement("div");
      const barVerticale = document.createElement("div");
      element.appendChild(barVerticale);
      const barHorizontale = document.createElement("div");
      element.appendChild(barHorizontale);

      barVerticale.setAttribute(
         "style",
         "width:2px; height:100%;  background-color:#58d2c3; top:0; left:50%; position: absolute"
      );
      barHorizontale.setAttribute(
         "style",
         "width:100%; height:2px; background-color:#58d2c3; top:50%; left:0; position: absolute"
      );
      /*
        element.className = 'screenToMap ol-unselectable ol-control';*/

      super({
         element: element,
         target: options.target,
      });
   }
}

const ProfileLocalizeMe = ({ userPrefs, updateUserInfo }) => {
   const [zoom, setZoom] = useState(null);
   const [center, setCenter] = useState(null);
   const [init, setInit] = useState();
   const [map, setMap] = useState(null);
   const mapRef = useRef();
   const [asData, setAsData] = useState(false);

   const [mapPrefs, setMapPrefs] = useState({
      map: {
         center_lon: {
            value: 8.802109,
            type: "number",
            label: "Centre - Longitude",
            disabled: false,
         },
         center_lat: {
            value: 41.946979,
            type: "number",
            label: "Centre - Latitude",
            disabled: false,
         },
         zoom: {
            value: 15,
            type: "number",
            label: "Zoom Initial",
            disabled: false,
         },
      },
   });

   const osm = new TileLayer({
      source: new OSM({
         //crossOrigin: "anonymous",
      }),
      title: "OSM",
      visible: true,
      baseLayer: true,
   });
   const buildMap = () => {
      let mapObject = new Map({
         layers: [osm],
         view: new View({
            center: fromLonLat([8.802, 41.946979]),
            zoom: 15,
            minZoom: 9,
            maxZoom: 19,
            rotation: 0.0,
            //constrainResolution: false,
         }),
      });

      mapObject.setTarget(mapRef.current);
      setMap(mapObject);
      mapObject.addControl(new GraticuleControl());

      mapObject.on("moveend", (e) => {
         setCenter(toLonLat(mapObject.getView().getCenter()));
         setZoom(mapObject.getView().getZoom());
         //console.log(mapObject.getView().getResolution())
      });
   };

   useEffect(() => {
      if (!map || init) return;
      center.length ? map.getView().setCenter(fromLonLat(center)) : null;
      zoom ? map.getView().setZoom(zoom) : null;
      setInit(true);
   }, [center, zoom]);

   useEffect(() => {
      //fetchUserPrefs();
   }, []);

   useEffect(() => {
      userPrefs ? setAsData(true) : false;
      let centerLonLat = null;

      if (userPrefs?.map?.center_lon?.value && userPrefs?.map?.center_lat?.value && userPrefs?.map?.zoom?.value) {
         centerLonLat = [Number(userPrefs.map.center_lon.value), Number(userPrefs.map.center_lat.value)];
         setCenter(centerLonLat);
         setZoom(userPrefs.map.zoom.value);
      } else {
         setCenter([8.802109, 41.946979]);
         setZoom(15);
      }
      userPrefs && !map ? buildMap() : null;
   }, [userPrefs]);

   const handleUpdatePrefs = (e) => {
      const args = {
         userPrefs: {
            ...userPrefs,
            map: {
               ...userPrefs.map,
               center_lon: {
                  //...userPrefs.map.center_lon,
                  value: e !== "reset" ? center[0] : null,
               },
               center_lat: {
                  //...userPrefs.map.center_lat,
                  value: e !== "reset" ? center[1] : null,
               },
               zoom: {
                  ...zoom,
                  value: e !== "reset" ? zoom : null,
               },
            },
         },
      };
      updateUserInfo({ prefs: args.userPrefs });
      toast.success("Nouvelle position enregistrée !");
   };

   const onSearchChange = (e) => {
      map.getView().setCenter(fromLonLat(e));
   };

   const handleClearLocalisation = () => {
      setZoom(null);
   };

   return (
      <div className={"w-100 h-100 text-black-50"} style={{ maxWidth: "750px" }}>
         <div className={"d-flex flex-column w-100 h-100"}>
            <h6 className={" font-weight-bold mb-0"} style={{ color: "black" }}>
               Position au démmarage
            </h6>
            <div className={"d-flex flex-row justify-content-between align-items-center w-100"}>
               <CommuneSearch
                  onSearchChange={(e) => onSearchChange(e)}
                  handleUpdatePrefs={(e) => handleUpdatePrefs(e)}
               />
            </div>

            <div ref={mapRef} id={"ue_localize"} className={"h-100 w-100"} />
            {center && zoom ? (
               <div
                  className={"d-flex flex-column flex-md-row justify-content-center items-center my-3 w-100"}
                  style={{ fontSize: "11px", fontWeight: "500" }}
               >
                  <div className={"d-flex flex-row my-2 my-md-0 mr-2"}>
                     <div className={"mr-2"}>
                        Longitude :{" "}
                        <span className={""}>
                           <NumberFormat
                              value={center[0]}
                              decimalScale={6}
                              fixedDecimalScale={true}
                              displayType={"text"}
                           />
                        </span>
                     </div>
                     <div>
                        Latitude :{" "}
                        <span className={" "}>
                           <NumberFormat
                              value={center[1]}
                              decimalScale={6}
                              fixedDecimalScale={true}
                              displayType={"text"}
                           />
                        </span>
                     </div>
                  </div>
                  <div>
                     Niveau de zoom :{" "}
                     <span className={""}>
                        <NumberFormat value={zoom} decimalScale={0} fixedDecimalScale={true} displayType={"text"} />
                        {/* {zoom} */}
                     </span>
                  </div>
               </div>
            ) : null}
            <br />
            <br />

            <div onClick={(e) => handleUpdatePrefs(e)} className={"btn btn-primary text-white font-weight-bold"}>
               <span
                  className={""}
                  style={{
                     display: "flex",
                     fontSize: "0.7rem",
                     flexDirection: "row",
                     alignContent: "center",
                     justifyContent: "center",
                     alignItems: "center",
                     height: "1rem",
                     width: "auto   ",
                  }}
               >
                  Enregistrer la nouvelle position
               </span>
            </div>
         </div>
      </div>
   );
};

const mapStateToProps = (state) => {
   return {
      userId: state.MeReducer.id,
      entity: state.MeReducer.entity,
      username: state.MeReducer.username,
      role: state.MeReducer.role,
      types: state.SubscribtionReducer.types,
      structureInfo: state.SubscribtionReducer.structureInfo,
      userPrefs: state.MeReducer?.prefs,
   };
};

const mapDispatchTProps = (dispatch) => {
   return {
      updateStructureInfo: (e) => dispatch({ type: "UPDATE_STRUCTURE_INFO", data: e }),
      updateUserInfo: (e) => dispatch({ type: "UPDATE_USER_STATUS", data: e }),
   };
};

export default connect(mapStateToProps, mapDispatchTProps)(ProfileLocalizeMe);
